import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Breadcrumb, Menu, Space, Layout    } from 'antd';
import { CardLayout, MYB2BTable, B2CTable, OPTable, PMLTable, PAYTable, BILLTable, SEMINARTable} from 'components/molecules';
import useStore from 'store';
import type { MenuProps } from 'antd';
import './index.scss';
import { useParams } from 'react-router-dom';
import { useMyMenu, useMyProject, useMyB2cProject, useMyPmlProject, useMyOperator, useMyNonOperator, useMyBill, useMyPayment, useMySeminar } from 'hooks'
import { useLocation, useNavigate } from 'react-router-dom';
import { addNewSearch } from 'utils/utils';
const { Content, Sider } = Layout;


const cx = classNames.bind('./index.scss');
type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
  } as MenuItem;
}


export interface MyRoomProps {}

const MyRoom = ({}: React.PropsWithChildren<MyRoomProps>): React.ReactElement => {
   /* ======================================================
   * variables
   * ====================================================== */
   const [actPage, setActPage] = useState<string>('');
   const [myMenu, setMymenu] = useState<MenuItem[]>([]);

   const auth = useStore((state) => state.auth);  
   const {main, sub} = useParams(); 




   const navigate = useNavigate();
   const location = useLocation();
  /* ======================================================
   * hooks
   * ====================================================== */

  const { menuList, isLoading, refetch:menuRefetct } = useMyMenu(''+auth.login?.id);  
  const { projectList, searchResult, refetch } = useMyProject(actPage, ''+auth.login?.id);  
  const { projectList: b2cProjectList, searchResult: b2cSearchResult, refetch: b2cRefetch } = useMyB2cProject(actPage, ''+auth.login?.id);  
  const { seminarList, searchResult: seminarSearchResult, refetch: seminarRefetch } = useMySeminar(actPage, ''+auth.login?.id);  
  const { pmlList, searchResult: pmlSearchResult, refetch: pmlRefetch } = useMyPmlProject(actPage, ''+auth.login?.id);  
  const { operatorList, searchResult: opSearchResult, refetch: opRefetch } = useMyOperator(actPage, ''+auth.login?.id);  
  const { noneList, searchResult: opNonSearchResult, refetch: opNonRefetch } = useMyNonOperator(actPage, ''+auth.login?.div);  
  const { billList, searchResult: billSearchResult, refetch: billRefetch, billHidden, hiddenSuccess } = useMyBill(actPage, ''+auth.login?.id);  
  const { paymentList, searchResult: paySearchResult, refetch: payRefetch, paymentHidden, hiddenPayment } = useMyPayment(actPage, ''+auth.login?.id);  
  
  /* ======================================================
   * events
   * ====================================================== */
  const onSearch = (data: any) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, data),
    });    
  };

  const onMemuClick: MenuProps['onClick'] = (e) => {
    setActPage(e.key);
    onSearch({ pageNo: 1 });
  };

  const onBillHiddenClick = (billid: number) => {
    billHidden({id:billid})
  };

  const onPaymentHiddenClick = (billid: number) => {
    paymentHidden({id:billid})
  };

  useEffect(() => {
    if (!!menuList) {
      const menus: MenuProps['items'] = [];
      const part1 = menuList.filter((menu) => (menu.group === 'b2b1' && menu.count > 0) || (menu.group === 'b2c1' && menu.count > 0) || (menu.group === 'pml1' && menu.count > 0) || (menu.group === 'seminar1' && menu.count > 0) || (menu.group === 'op1' && menu.count > 0));
      if (!!part1 && part1.length > 0) {
        menus.push(getItem(
          '진행중/모집중과정', 'pjt1', null,
          part1.map((item) => getItem(<label>{item.groupname + '(' + item.count + ')'}</label>, item.group)))
        ) 
      }

      const part2 = menuList.filter((menu) => (menu.group === 'b2b2' && menu.count > 0) || (menu.group === 'b2c2' && menu.count > 0) || (menu.group === 'pml2' && menu.count > 0) || (menu.group === 'seminar2' && menu.count > 0));
      if (!!part2 && part2.length > 0) {
        if (menus.length > 0) menus.push({ type: 'divider' });
        menus.push(getItem(
          '논의중/마감과정', 'pjt2', null,
          part2.map((item) => getItem(<label>{item.groupname + '(' + item.count + ')'}</label>, item.group)))
        ) 
      } 
      
      const part3 = menuList.filter((menu) => (menu.group === 'b2b3' && menu.count > 0) || (menu.group === 'b2c3' && menu.count > 0) || (menu.group === 'pml3' && menu.count > 0) || (menu.group === 'op2' && menu.count > 0));
      if (!!part3 && part3.length > 0) {
        if (menus.length > 0) menus.push({ type: 'divider' });
        menus.push(getItem(
          '완료', 'pjt3', null,
          part3.map((item) => getItem(<label>{item.groupname + '(' + item.count + ')'}</label>, item.group)))
        ) 
      }   

      if (auth.login?.div === '101' || auth.login?.div === '999') {
        const part4 = menuList.filter((menu) => (menu.group === 'op3' && menu.count > 0));
        if (!!part4 && part4.length > 0) {
          if (menus.length > 0) menus.push({ type: 'divider' });
          menus.push(getItem(
            <label>{'현장운영-미배정'+ '(' + part4[0].count + ')'}</label>, 'op3')
          ) 
        } 
      }
      
      const part5 = menuList.filter((menu) => (menu.group === 'bill1' && menu.count > 0) || (menu.group === 'bill2' && menu.count > 0));
      if (!!part5 && part5.length > 0) {
        if (menus.length > 0) menus.push({ type: 'divider' });
        menus.push(getItem(
          'MY매출발행', 'mybill', null,
          part5.map((item) => getItem(<label>{item.groupname + '(' + item.count + ')'}&nbsp;{(item.newcnt>0) && (<span style={{color:'#FF0000', fontSize:'10px'}}>New </span>)}</label>, item.group)))
        ) 
      }        

      const part6 = menuList.filter((menu) => (menu.group === 'pay1' && menu.count > 0) || (menu.group === 'pay2' && menu.count > 0));
      if (!!part6 && part6.length > 0) {
        if (menus.length > 0) menus.push({ type: 'divider' });
        menus.push(getItem(
          'MY외부강사비요청', 'mypayment', null,
          part6.map((item) => getItem(<label>{item.groupname + '(' + item.count + ')'}&nbsp;{(item.newcnt>0) && (<span style={{color:'#FF0000', fontSize:'10px'}}>New </span>)} </label>, item.group)))
        ) 
      }   

      menuList.some(function(item) {
        if (item.count > 0) {
          //setActPage(item.group);
          return true;
        }
      })

      setMymenu(menus);
    }
    
  }, [menuList])  

  useEffect(() => {
    if (hiddenSuccess) {
      billRefetch();
      menuRefetct();
    }
    
  }, [hiddenSuccess])    

  useEffect(() => {
    if (hiddenPayment) {
      payRefetch();
      menuRefetct();
    }
    
  }, [hiddenPayment])      
  
  
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>MyRoom</Breadcrumb.Item>
        <Breadcrumb.Item>{main}</Breadcrumb.Item>
        <Breadcrumb.Item>{sub}</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
      <Layout>
        <Sider width={200} theme="light" >
          <Menu
            onClick={onMemuClick}
            theme="light" 
            style={{ width: 200 }}
            mode="inline" 
            selectedKeys={[actPage]}
            defaultOpenKeys={['pjt1', 'pjt2', 'pjt3', 'mybill', 'mypayment']}         
            items={myMenu}
          />
        </Sider>
        <Content style={{ paddingLeft: '10px', paddingTop: '10px', minHeight: 280,  width:'calc(100% - 220px)', background:'white' }}>
          <div style={{width:'100%'}}>
            {(actPage === 'b2b1')?(
              <MYB2BTable 
                pType='confirm'
                projectList={projectList} 
                searchResult={searchResult} 
                hiddenColumns={['project_step', 'history']}
                refetch={refetch}/>
            ):(actPage === 'b2b2')?(
              <MYB2BTable 
                pType='consult'
                projectList={projectList} 
                searchResult={searchResult} 
                hiddenColumns={['not_publish_pirce', 'calc_out_lecturer_price']}
                refetch={refetch}/>
            ):(actPage === 'b2b3')?(
              <MYB2BTable 
                pType='confirm'
                projectList={projectList} 
                searchResult={searchResult} 
                hiddenColumns={['project_step', 'not_publish_pirce', 'calc_out_lecturer_price']}
                refetch={refetch}/>
            ):(actPage === 'b2c1')?(
              <B2CTable 
                projectList={b2cProjectList} 
                searchResult={b2cSearchResult} 
                hiddenColumns={['sales_profit', 'time_price']}
                title={""}
                register
                refetch={b2cRefetch}/>
            ):(actPage === 'b2c2')?(
              <B2CTable 
                projectList={b2cProjectList} 
                searchResult={b2cSearchResult} 
                hiddenColumns={['sales_profit', 'time_price']}
                title={""}
                register={false}              
                refetch={b2cRefetch}/>
            ):(actPage === 'b2c3')?(
              <B2CTable 
                projectList={b2cProjectList} 
                searchResult={b2cSearchResult} 
                hiddenColumns={['not_publish_pirce', 'expect_price']}
                title={""}
                register={false}              
                refetch={b2cRefetch}/>
            ):(actPage === 'pml1')?(
              <PMLTable 
                pmlList={pmlList} 
                searchResult={pmlSearchResult} 
                hiddenColumns={[]}
                title={""}
                register
                refetch={pmlRefetch}/>
            ):(actPage === 'pml2')?(
              <PMLTable 
                pmlList={pmlList} 
                searchResult={pmlSearchResult} 
                hiddenColumns={[]}
                title={""}
                register={false}              
                refetch={pmlRefetch}/>
            ):(actPage === 'pml3')?(
              <PMLTable 
                pmlList={pmlList} 
                searchResult={pmlSearchResult} 
                hiddenColumns={[]}
                title={""}
                register={false}              
                refetch={pmlRefetch}/>
            ):(actPage === 'op1')?(
              <OPTable 
                operatorList={operatorList} 
                searchResult={opSearchResult} 
                hiddenColumns={['check_count']}
                register={false}              
                refetch={opRefetch}/>
            ):(actPage === 'op2')?(
              <OPTable 
                operatorList={operatorList}  
                searchResult={opSearchResult} 
                hiddenColumns={['check_count']}
                register={false}              
                refetch={opRefetch}/>
            ):(actPage === 'op3')?(
              <OPTable 
                operatorList={noneList}  
                searchResult={opNonSearchResult} 
                hiddenColumns={['operator_name', 'lecturer_name', 'lecture_place', 'pm', 'cm']}
                register={false}              
                refetch={opNonRefetch}/>
            ):(actPage === 'bill1')?(
              <BILLTable 
                billList={billList}  
                searchResult={billSearchResult} 
                hiddenColumns={['who_create', 'confirm_at', 'created_at', 'drop_at', 'drop_memo', 'hidden', 'request']}
                refetch={billRefetch}
                refetch2={menuRefetct}/>
            ):(actPage === 'bill2')?(
              <BILLTable 
                billList={billList}  
                searchResult={billSearchResult} 
                hiddenColumns={['who_create', 'confirm_at', 'created_at', 're_request_at']}
                refetch={billRefetch}
                refetch2={menuRefetct}
                onhidden={onBillHiddenClick}/>
            ):(actPage === 'pay1')?(
              <PAYTable 
                paymentList={paymentList}
                searchResult={paySearchResult} 
                hiddenColumns={['who_create', 'confirm_at', 'created_at', 'drop_at', 'drop_memo', 'hidden', 'request']}
                refetch={payRefetch}
                refetch2={menuRefetct}/>
            ):(actPage === 'pay2')?(
              <PAYTable 
                paymentList={paymentList}
                searchResult={paySearchResult} 
                hiddenColumns={['who_create', 'confirm_at', 'created_at', 're_request_at']}
                refetch={payRefetch}
                refetch2={menuRefetct}
                onhidden={onPaymentHiddenClick}/>
            ):(actPage === 'seminar1')?(
              <SEMINARTable 
                projectList={seminarList} 
                searchResult={seminarSearchResult} 
                hiddenColumns={['sales_profit', 'time_price']}
                title={""}
                register
                refetch={seminarRefetch}/>
            ):(actPage === 'seminar2')?(
              <SEMINARTable 
                projectList={seminarList} 
                searchResult={seminarSearchResult} 
                hiddenColumns={['sales_profit', 'time_price']}
                title={""}
                register={false}              
                refetch={seminarRefetch}/>
            ):(<></>)}
            </div>

        </Content>
      </Layout>
    </CardLayout>
  );
};

export default MyRoom;
